import React from "react";

const ContactUsBlock = () => {
  return (
    <>
      <div className="bg-white rounded-3xl border border-gray-200 shadow-xl overflow-hidden px-6 sm:px-8 lg:px-12 py-10 max-w-5xl mx-auto">
  {/* Heading + Subtext */}
  <div className="text-center mb-10">
    <h3 className="text-3xl sm:text-4xl font-bold text-gray-900">
      Contact Information
    </h3>
    <p className="mt-2 text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
      Fill up the form and our team will get back to you shortly.
    </p>
  </div>

  {/* Contact Form */}
  <form
    action="https://formspree.io/f/mzbqdzwv"
    method="POST"
    autoComplete="off"
    className="space-y-6"
  >
    {/* Name Fields */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <label htmlFor="fname" className="text-gray-700 font-medium block">
          First Name
        </label>
        <input
          type="text"
          name="fname"
          id="fname"
          className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
          placeholder="First Name"
          required
        />
      </div>
      <div className="space-y-2">
        <label htmlFor="lname" className="text-gray-700 font-medium block">
          Last Name
        </label>
        <input
          type="text"
          name="lname"
          id="lname"
          className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
          placeholder="Last Name"
          required
        />
      </div>
    </div>

    {/* Email & Phone */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <label htmlFor="email" className="text-gray-700 font-medium block">
          Email
        </label>
        <input
          type="email"
          name="email"
          id="email"
          className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
          placeholder="you@example.com"
          required
        />
      </div>
      <div className="space-y-2">
        <label htmlFor="tel" className="text-gray-700 font-medium block">
          Phone
        </label>
        <input
          type="tel"
          name="tel"
          id="tel"
          className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
          placeholder="+91 98765 43210"
        />
      </div>
    </div>

    {/* Message */}
    <div className="space-y-2">
      <label htmlFor="message" className="text-gray-700 font-medium block">
        Message
      </label>
      <textarea
        name="message"
        id="message"
        rows="6"
        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 resize-none"
        placeholder="Tell us about your project, goals, or questions..."
        required
      ></textarea>
    </div>

    {/* Submit Button */}
    <div className="flex justify-end">
      <button
        type="submit"
        className="group px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-full font-semibold text-base sm:text-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/25 flex items-center gap-2"
      >
        Send Message
      </button>
    </div>
  </form>
</div>
    </>
  );
};

export default ContactUsBlock;
